import { notifications } from '@mantine/notifications';

export function notifySuccess(message: string) {
    notifications.show({ message, color: 'brand' });
}

export function notifyError(error: unknown) {
    const message = error instanceof Error ? error.message : String(error);
    notifications.show({ title: 'Ошибка', message, color: 'red' });
}
